
























































































































































































































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  set,
  useFetch,
  useRoute,
  useRouter,
  watchEffect
} from '@nuxtjs/composition-api'
import { AxiosError } from 'axios'
import {
  faAngleLeft,
  faAngleRight,
  faMap
} from '@fortawesome/free-solid-svg-icons'
import { ciTimes } from '~/icons/source/regular/times'
import { ciHistory } from '~/icons/source/regular/history'
import { useDep } from '~/compositions/dependency-container'
import { useSnackbar } from '~/compositions/snackbar'
import { useLogger } from '~/compositions/logger'
import { useI18n } from '~/compositions/i18n'
import { handleError } from '~/utils/http'
import SearchService from '~/services/search/SearchService'
import HierarchicalCategoryService from '~/services/category/HierarchicalCategoryService'
import { CategoryId, HierarchicalCategory } from '~/models/category/types'
import CCard from '~/components/shared/configurable/card/CCard.vue'
import FeedSideButton from '~/components/car/classifieds/index/feeds/sidebar/FeedSideButton.vue'
import CCategoryIcon from '~/components/shared/configurable/category/CCategoryIcon.vue'
import QuickFiltersForm from '~/components/car/categories-and-filters/QuickFiltersForm.vue'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_SEARCH_NS,
  SearchState
} from '~/store/modules/shared/classifieds/search/state'
import {
  CLEAR_ALL,
  SET_CURRENT_ROUTE,
  SET_LOADING_FACETS,
  SET_SEARCH_TYPE
} from '~/store/modules/shared/classifieds/search/mutation-types'
import {
  USER_AGENT_NS,
  UserAgentState
} from '~/store/modules/shared/userAgent/state'
import ClearAllHandler from '~/components/car/classifieds/search/facets/handlers/ClearAllHandler.vue'
import useQuickSearchMenu from '~/compositions/quick-search-menu/quick-search-menu'
import Facets from '~/components/shared/quick-search/facets/Facets.vue'
import {
  QUICK_SEARCH_NS,
  QuickSearchState
} from '~/store/modules/shared/quickSearch/state'
import {
  RESET_PARAMS,
  SET_CONFIG
} from '~/store/modules/shared/quickSearch/mutation-types'
import { Config } from '~/models/quick-search/types'
import CDirectionsButton from '~/components/shared/configurable/map/CDirectionsButton.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import RecentSearchModal from '~/components/plot/landing/RecentSearchModal/RecentSearchModal.vue'
import SmallClassifiedsQuickMenu from '~/components/car/categories-and-filters/SmallClassifiedsQuickMenu.vue'
import CategoriesList from '~/components/car/categories-and-filters/CategoriesList.vue'
import CSpinner from '~/components/shared/configurable/CSpinner.vue'
import QuickSearchContainer from '~/components/shared/quick-search/QuickSearchContainer.vue'
import QuickSearchItem from '~/components/shared/quick-search/QuickSearchItem.vue'
import QuickSearchMobileMenu from '~/components/car/categories-and-filters/QuickSearchMobileMenu.vue'
import { useStatic } from '~/compositions/useStatic'
import { categoriesMap } from '~/constants/quick-search'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import qs from 'qs'
import ScrollService from '~/services/scroll/ScrollService'
import { DriverCookieName } from '~/constants/driver'
import CookiesService from '~/services/CookiesService'
import CPosting from '~/components/shared/configurable/ad/CPosting.vue'
import VehicleServiceQuickSearchForm from '~/components/car/categories-and-filters/VehicleServiceQuickSearchForm.vue'

export default defineComponent({
  middleware({ redirect, route, store, error: errorFn }) {
    store.state.classifieds.search.isQuickSearch = true
    const isPc = store.getters[`${USER_AGENT_NS}/isPc`]

    if (route.params.root) {
      const rootCat = categoriesMap.find(c => c.name === route.params.root)
      if (!rootCat) {
        return errorFn({ statusCode: 404 })
      }

      if (route.params.category) {
        const cat = rootCat?.children?.find(
          r => r.name === route.params.category
        )
        const thridLevelCheck = rootCat?.children?.find(r =>
          r.children?.some(c => c.name === route.params.category)
        )
        if (!cat && !thridLevelCheck) {
          return errorFn({ statusCode: 404 })
        }
      }
    }

    if (
      ['vehicles', 'parts'].includes(route.params.root) &&
      route.params.category === undefined
    ) {
      return redirect({
        name: '__classifieds_quick_search',
        params: {
          root: route.params.root,
          category: route.params.root === 'parts' ? 'for-cars' : 'cars'
        }
      })
    }
    if (isPc && !route.params.root && !route.params.category) {
      return redirect({
        name: '__classifieds_quick_search',
        params: { root: 'vehicles', category: 'cars' }
      })
    }
    if (!isPc) {
      if (
        route.path === '/quick-search/rentals' ||
        route.path === '/quick-search/rentals/'
      ) {
        redirect('/rentals/search')
      }
      if (
        route.path === '/quick-search/plot' ||
        route.path === '/quick-search/plot/'
      ) {
        redirect('/plot/search')
      }
    }
  },
  components: {
    VehicleServiceQuickSearchForm,
    CPosting,
    CCard,
    FeedSideButton,
    CCategoryIcon,
    QuickFiltersForm,
    ClearAllHandler,
    Facets,
    CDirectionsButton,
    CImg,
    RecentSearchModal,
    SmallClassifiedsQuickMenu,
    CategoriesList,
    CSpinner,
    QuickSearchContainer,
    QuickSearchItem,
    QuickSearchMobileMenu
  },
  name: 'QuickSearchPage',
  setup() {
    const cookiesService = useDep(CookiesService)

    const parentID = ref(String(CategoryId.VEHICLES))
    const thirdLevelSubCategoryId = ref('')
    const selectedSubcategoryId = ref('')
    const isThirdLevelSubCategorySelected = ref(false)
    const top = ref(null)

    const facets = computed(() => state.facets)

    const {
      computeUrlFromCategoryId,
      filteredFacets,
      quickSearchHeading,
      topLevelCategories,
      isFullWidth,
      isPartsSection,
      isBicycleSection,
      hasSubcategoriesMenus,
      findThirdLevelParent,
      parseCategory
    } = useQuickSearchMenu(
      parentID,
      selectedSubcategoryId,
      thirdLevelSubCategoryId,
      facets,
      isThirdLevelSubCategorySelected
    )

    onMounted(() => {
      const moreFiltersDriveCookie = cookiesService.get(
        DriverCookieName.QUICK_SEARCH_MORE_FILTERS
      )
      // Scroll to top only when the more filters button is not going to be highlighted
      if (moreFiltersDriveCookie) {
        scrollService.scrollToTop()
      }
      window.history.replaceState(
        { isInSearchPage: true, isQuickSearch: true },
        '',
        window.location.href
      )
      addEventListeners()
    })
    onUnmounted(() => {
      classifiedSearchCommit(SET_SEARCH_TYPE, false)
      removeEventListeners()
    })
    const {
      state,
      commit: classifiedSearchCommit,
      dispatch,
      getters
    } = useNamespacedStore<SearchState>(CLASSIFIED_SEARCH_NS)

    const { getters: userAgentGetters } = useNamespacedStore<UserAgentState>(
      USER_AGENT_NS
    )

    const {
      state: quickSearchState,
      commit,
      dispatch: quickSearchDispatch
    } = useNamespacedStore<QuickSearchState>(QUICK_SEARCH_NS)

    const scrollService = useDep(ScrollService)
    const searchService = useDep(SearchService)
    const hierarchicalCategoryService = useDep(HierarchicalCategoryService)
    const snackbar = useSnackbar()
    const logger = useLogger()
    const { t } = useI18n()
    const route = useRoute()
    const router = useRouter()
    const s = useStatic()

    const quickSearches = computed(() => quickSearchState.quickSearches)

    const handleShowCorrectFormComingFromResults = () => {
      const { root } = route.value.params
      if (root) {
        const rootID = parseCategory(root, 'name')

        parentID.value = rootID as string

        topLevelCategories.value.forEach(item => set(item, 'selected', false))
        const foundPreviouslySelecteCategoryIndex = topLevelCategories.value.findIndex(
          cat => cat.categoryId.toString() === rootID
        )

        set(topLevelCategories.value, foundPreviouslySelecteCategoryIndex, {
          ...topLevelCategories.value[foundPreviouslySelecteCategoryIndex],
          selected: true
        })
      }
    }

    const loadCategoriesForSelectedParentId = async () => {
      const map = await hierarchicalCategoryService.getQuickSearchCategoryMap(
        parentID.value,
        Number(parentID.value),
        true
      )
      subTreeCategories.value = Array.from(
        map.values()
      ) as HierarchicalCategory[]
    }

    const { fetch } = useFetch(
      async (): Promise<any> => {
        try {
          classifiedSearchCommit(SET_CURRENT_ROUTE, router.currentRoute)

          if (process.client && facets.value.length > 0) {
            classifiedSearchCommit(CLEAR_ALL, true)
          }
          handleClearBtnVisibility(true)

          if (!ignoreShowCorrectFormHandler.value) {
            handleShowCorrectFormComingFromResults()
          }
          // parentId sent through router for fetching correct quick search menus
          if (route.value.params.parentId) {
            parentID.value = route.value.params.parentId
          }

          if (process.server && route.value.params.root) {
            parentID.value = parseCategory(route.value.params.root, 'name')

            if ([String(CategoryId.RENTALS)].includes(parentID.value)) {
              await fetchPopularRentalSearches()
            }

            const selectedTopCategoryIndex = topLevelCategories.value.findIndex(
              el => el.id === parentID.value
            )

            topLevelCategories.value.forEach(item =>
              set(item, 'selected', false)
            )

            set(topLevelCategories.value, selectedTopCategoryIndex, {
              ...topLevelCategories.value[selectedTopCategoryIndex],
              selected: true
            })
          }

          if (parentID.value === String(CategoryId.PLOT)) {
            selectedSubcategoryId.value = ''
            await fetchPlotFacets()
            directionsLink.value = quickSearchState.targets.searchMap?.seoUrl
            classifiedSearchCommit(SET_LOADING_FACETS, false)
            return
          }

          // set loading state for facets
          classifiedSearchCommit(SET_LOADING_FACETS, true)
          // get subcategories menu
          if (subTreeCategories.value.length === 0) {
            await loadCategoriesForSelectedParentId()
          }

          let urlCategory = parseCategory(route.value.params.category, 'name')

          if (process.client) {
            const { category } = extractParamsFromUrl(window.location.href)
            urlCategory = parseCategory(category, 'name')
          }
          // find selected subcategory index based on query param in the url
          const selectedSubCategoryIndex = subTreeCategories.value.findIndex(
            el => el.id === urlCategory
          )

          if (urlCategory) {
            const categoryParent = findThirdLevelParent(
              categoriesMap,
              urlCategory
            )
            if (categoryParent) {
              isThirdLevelSubCategorySelected.value = true
              selectedSubcategoryId.value = categoryParent.id
              thirdLevelSubCategoryId.value = urlCategory
            }
          }

          // keep track of selected subTreeCategory and its ID value based on selectedSubCategoryIndex
          if (
            [
              String(CategoryId.RENTALS),
              String(CategoryId.XYMA),
              String(CategoryId.SERVICE)
            ].includes(parentID.value)
          ) {
            selectedSubcategoryId.value = parentID.value
          } else if (!isThirdLevelSubCategorySelected.value) {
            // no third level subcategory is available to be selected
            if (selectedSubCategoryIndex === -1) {
              subTreeCategories.value[0].selected = true
              selectedSubcategoryId.value = subTreeCategories.value[0].id
            } else {
              subTreeCategories.value[selectedSubCategoryIndex].selected = true
              selectedSubcategoryId.value =
                subTreeCategories.value[selectedSubCategoryIndex].id
            }
          } else {
            // select appropriate subcategory when third level subcategory is selected
            const selectedSubCategoryIndex = subTreeCategories.value.findIndex(
              el => el.id === selectedSubcategoryId.value
            )
            subTreeCategories.value[selectedSubCategoryIndex].selected = true
            selectedSubcategoryId.value =
              subTreeCategories.value[selectedSubCategoryIndex].id
          }

          const category = isThirdLevelSubCategorySelected.value
            ? thirdLevelSubCategoryId.value
            : selectedSubcategoryId.value

          let categoryToUse = category
          if (route.value.query.category) {
            if (Array.isArray(route.value.query.category)) {
              categoryToUse = [category, ...route.value.query.category]
            } else {
              categoryToUse = [category, route.value.query.category]
            }
          }
          let routeToUse = router.resolve({
            name: '__classifieds_quick_search',
            query: {
              root: parentID.value,
              ...route.value.query,
              category: categoryToUse
            }
          }).route as any

          if (process.client && typeof window !== 'undefined') {
            const urlQueryParams = qs.parse(window.location.search, {
              ignoreQueryPrefix: true
            })

            let clientCategoryToUse = category

            if (urlQueryParams.category) {
              if (Array.isArray(urlQueryParams.category)) {
                clientCategoryToUse = [category, ...urlQueryParams.category]
              } else {
                clientCategoryToUse = [category, urlQueryParams.category]
              }
            }
            routeToUse = {
              fullPath: window.location.pathname + window.location.search,
              // @ts-ignore
              query: {
                root: parentID.value,
                ...urlQueryParams,
                category: clientCategoryToUse
              },
              path: window.location.pathname,
              name: '__classifieds_quick_search'
            }
          }

          await searchService.createSearch({
            route: routeToUse,
            mapSearch: false,
            errorFn: () => {},
            isQuickSearch: true
          })

          handleClearBtnVisibility(false)
        } catch (err) {
          handleError(err as AxiosError, snackbar, logger, t)
        }
      }
    )

    const forceHide = ref(false)
    const ignoreShowCorrectFormHandler = ref(false)
    const modalIsOpen = ref(false)
    const directionsLink = ref<string>()
    const subTreeCategories = ref<HierarchicalCategory[]>([])
    const thirdLevelSubTreeCategories = ref<HierarchicalCategory[]>([])
    const windowWidth = ref<number>()
    const xymaMenu = ref(null)

    let categoryOnLoad = route.value.params.category
    if (process.client) {
      const { category } = extractParamsFromUrl(window.location.href)
      categoryOnLoad = category
    }
    selectedSubcategoryId.value = parseCategory(categoryOnLoad, 'name')

    const showQuickSearchMobileMenu = computed(() => {
      const pattern = RegExp('^/quick-search/?$')
      return pattern.test(route.value.path)
    })
    const hideCategories = computed(() => {
      return process.client ? (windowWidth.value as number) <= 992 : false
    })

    const isServiceCategory = computed(
      () => parentID.value === String(CategoryId.SERVICE)
    )
    const isXymaCategory = computed(
      () => parentID.value === String(CategoryId.XYMA)
    )
    const isPlotCategory = computed(
      () => String(CategoryId.PLOT) === parentID.value
    )
    const isRentalsCategory = computed(
      () => String(CategoryId.RENTALS) === parentID.value
    )
    const PlotOrRentalImgUrl = computed(() =>
      String(CategoryId.PLOT) === parentID.value
        ? s('/nuxt-static/img/quick-search/aggelies-akinhtwn-desktop.png')
        : s('/nuxt-static/img/quick-search/aggelies-enoikiasewn-desktop.png')
    )
    const isPlotOrRentalsCategory = computed(() =>
      [String(CategoryId.PLOT), String(CategoryId.RENTALS)].includes(
        parentID.value
      )
    )
    const showOverlay = computed(
      () => !hasLoadedFacets.value && parentID.value !== String(CategoryId.PLOT)
    )
    const isHobbiesOrCommercialOrCampersCategory = computed(() =>
      [
        String(CategoryId.HOBBIES),
        String(CategoryId.COMMERCIAL),
        String(CategoryId.CAMPERS)
      ].includes(selectedSubcategoryId.value)
    )
    const isProfessionalQuickSearch = computed(
      () => selectedSubcategoryId.value === String(CategoryId.COMMERCIAL)
    )
    const hasLoadedFacets = computed(() => getters('hasLoadedFacets'))
    const getSeoUrl = computed(() => getters('getSeoUrl'))
    const isPc = computed(() => userAgentGetters('isPc'))
    const icons = {
      faArrowRight: faAngleRight,
      faArrowLeft: faAngleLeft,
      clear: ciTimes,
      map: faMap,
      history: ciHistory,
      externalLink: ciExternalLink
    }

    const toggleModal = () => {
      modalIsOpen.value = !modalIsOpen.value
    }

    const fetchSubcategoriesOfSubcategory = async (subcategoryId: string) => {
      const response = await hierarchicalCategoryService.getQuickSearchCategoryMap(
        subcategoryId,
        +subcategoryId,
        true
      )
      thirdLevelSubTreeCategories.value = []
      Array.from(response).reduce((acc: any, cur: any) => {
        acc.push(cur[1])
        return acc
      }, thirdLevelSubTreeCategories.value)
    }

    const goBack = () => {
      const parent = findThirdLevelParent(
        categoriesMap,
        thirdLevelSubCategoryId.value
      )
      if (parent) {
        const index = subTreeCategories.value.findIndex(c => c.id === parent.id)
        handleSubCategorySelection({ id: parent.id, index })
      }
    }

    function addEventListeners() {
      window.addEventListener('popstate', handlePopState, false)
      window.addEventListener('resize', () => {
        windowWidth.value = window.innerWidth
      })
    }

    function removeEventListeners() {
      window.removeEventListener('popstate', handlePopState)
    }

    function handlePopState(event: any) {
      const categoryIsXyma = parentID.value === String(CategoryId.XYMA)
      if (!event?.state || isServiceCategory.value || categoryIsXyma) {
        return
      }

      if (!event.state.isInSearchPage) {
        if (event.state.resetSearchState) {
          window.history.replaceState(
            { isInSearchPage: true },
            '',
            window.location.href
          )
        }
        return
      }

      if (event.state.isQuickSearch) {
        const { root, category } = extractParamsFromUrl(window.location.href)

        const rootID = parseCategory(root, 'name')
        const rootIndex = topLevelCategories.value.findIndex(
          c => c.id === rootID
        )

        handleTopCategorySelection(
          {
            id: rootID,
            index: rootIndex
          },
          false
        )

        if (category) {
          const categoryID = parseCategory(category, 'name')
          const categoryIndex = subTreeCategories.value.findIndex(
            c => c.id === categoryID
          )
          if (categoryIndex >= 0) {
            handleSubCategorySelection(
              {
                id: categoryID,
                index: categoryIndex
              },
              false
            )
          }
        }
      }
    }

    function extractParamsFromUrl(u: string) {
      const url = new URL(u)
      const pathParts = url.pathname.split('/').filter(Boolean)
      return {
        root: pathParts[1],
        category: pathParts[2]
      }
    }

    async function fetchPopularRentalSearches() {
      const config: Config = {
        baseUrl: '/api/rentals/quick-search/',
        title: String(t('vehicle rentals')),
        rootCategoryId: CategoryId.RENTALS,
        facetsCols: {
          pickup_location: 3,
          category: 2,
          rental_period: 4
        }
      }
      commit(SET_CONFIG, config)
      await Promise.all([
        quickSearchDispatch(`loadData`),
        quickSearchDispatch(`loadCategoriesData`)
      ])
    }

    const handleTopCategorySelection = async (
      {
        id,
        index
      }: {
        id: string
        index: number
      },
      updateUrl: boolean = true
    ) => {
      ignoreShowCorrectFormHandler.value = true

      if (String(CategoryId.JOBS) === id) {
        return router.push({
          path: '/jobs',
          query: { category: id }
        })
      }

      if (String(CategoryId.DEALS) === id) {
        return router.push({
          path: '/deals'
        })
      }

      if (String(CategoryId.RENTALS) === id) {
        await fetchPopularRentalSearches()
      }

      isThirdLevelSubCategorySelected.value = false
      thirdLevelSubCategoryId.value = ''

      if (parentID.value === id && +id !== CategoryId.XYMA) return

      topLevelCategories.value.forEach(item => set(item, 'selected', false))

      set(topLevelCategories.value, index, {
        ...topLevelCategories.value[index],
        selected: true
      })

      parentID.value = id

      if (id === CategoryId.SERVICE) {
        await dispatch('updateUrl', '/quick-search/service')
        return
      }

      const parentObject = parseCategory(parentID.value, 'id', true)

      if (updateUrl) {
        const resolvedRoute = router.resolve({
          name: '__classifieds_quick_search',
          params: {
            root: parseCategory(parentID.value, 'id'),
            category: parentObject?.children?.length
              ? parentObject.children[0].name
              : undefined
          }
        }).href

        if (
          window.location.pathname !== resolvedRoute ||
          +parentID.value === CategoryId.XYMA
        ) {
          await dispatch('updateUrl', resolvedRoute)

          if (+parentID.value === CategoryId.XYMA && xymaMenu.value) {
            xymaMenu.value.isSubCategorySelected = false
            xymaMenu.value.selectedCategoryName = ''
          }
        }
      }

      await loadCategoriesForSelectedParentId()
      fetch()
    }

    const handleSubCategorySelection = async (
      {
        id,
        index
      }: {
        id: string
        index: number
      },
      updateUrl: boolean = true
    ) => {
      isThirdLevelSubCategorySelected.value = false
      thirdLevelSubCategoryId.value = ''

      const alreadySelected = subTreeCategories.value[index].selected
      if (!alreadySelected) {
        subTreeCategories.value.forEach(item => set(item, 'selected', false))
        const foundIndex = subTreeCategories.value.findIndex(
          item => item.id === id
        )
        set(subTreeCategories.value, foundIndex, {
          ...subTreeCategories.value[foundIndex],
          selected: true
        })

        selectedSubcategoryId.value = id
      }

      if (updateUrl) {
        const resolvedRoute = router.resolve({
          name: '__classifieds_quick_search',
          params: {
            root: parseCategory(parentID.value, 'id'),
            category: parseCategory(id, 'id')
          }
        }).href
        await dispatch('updateUrl', resolvedRoute)
      }
      if (
        [
          String(CategoryId.HOBBIES),
          String(CategoryId.COMMERCIAL),
          String(CategoryId.CAMPERS)
        ].includes(id) ||
        alreadySelected
      ) {
        return
      }
      fetch()
    }

    const handleThirdLevelSubcategorySelection = async (categoryId: string) => {
      isThirdLevelSubCategorySelected.value = true
      thirdLevelSubCategoryId.value = categoryId

      const resolvedRoute = router.resolve({
        name: '__classifieds_quick_search',
        params: {
          root: parseCategory(parentID.value, 'id'),
          category: parseCategory(categoryId, 'id')
        }
      }).href
      await dispatch('updateUrl', resolvedRoute)
      fetch()
    }

    const fetchPlotFacets = async (): Promise<any> => {
      commit(RESET_PARAMS)
      const config: Config = {
        baseUrl: '/api/plot/quick-search/',
        rootCategoryId: CategoryId.PLOT,
        flexGrow: {
          offertype: false,
          category: true,
          location: true
        },
        hideOnMobileWhenNoSearchables: {
          category: true
        }
      }
      commit(SET_CONFIG, config)
      await quickSearchDispatch(`loadData`)
    }

    const handleClearBtnVisibility = (e: boolean) => {
      forceHide.value = e
    }

    watchEffect(() => {
      if (
        [
          String(CategoryId.HOBBIES),
          String(CategoryId.COMMERCIAL),
          String(CategoryId.CAMPERS)
        ].includes(selectedSubcategoryId.value)
      ) {
        fetchSubcategoriesOfSubcategory(selectedSubcategoryId.value)
      }
    })

    return {
      topLevelCategories,
      subTreeCategories,
      handleTopCategorySelection,
      handleSubCategorySelection,
      icons,
      filteredFacets,
      isFullWidth,
      quickSearchHeading,
      selectedSubcategoryId,
      isPc,
      loadCategoriesForSelectedParentId,
      thirdLevelSubTreeCategories,
      handleThirdLevelSubcategorySelection,
      isThirdLevelSubCategorySelected,
      thirdLevelSubCategoryId,
      getSeoUrl,
      computeUrlFromCategoryId,
      isPartsSection,
      hasSubcategoriesMenus,
      parentID,
      directionsLink,
      toggleModal,
      modalIsOpen,
      isBicycleSection,
      fetch,
      handleClearBtnVisibility,
      forceHide,
      hasLoadedFacets,
      goBack,
      removeEventListeners,
      CategoryId,
      quickSearches,
      hideCategories,
      showQuickSearchMobileMenu,
      isProfessionalQuickSearch,
      isHobbiesOrCommercialOrCampersCategory,
      showOverlay,
      isPlotOrRentalsCategory,
      PlotOrRentalImgUrl,
      isRentalsCategory,
      isPlotCategory,
      isXymaCategory,
      top,
      xymaMenu,
      isServiceCategory
    }
  }
})
